import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../../services/PremissionChecker";
function DefineExamRemarks() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [remarksData, setRemarksData] = useState([]);
  const [addClassLoading, setAddClassLoading] = useState(false);

  const [addRemarkModal, setAddRemarkModal] = useState(false);
  const [remarkName, setRemarkName] = useState("");

  const [editRemarkModal, setEditRemarkModal] = useState(false);
  const [editRemarkName, setEditRemarkName] = useState("");
  const [editRemarkId, setEditRemarkId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteRemarkId, setDeleteRemarkId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getExamRemarks();
  }, []);

  const getExamRemarks = async () => {
    setloading(true);
    await fetch(`${baseUrl}/exam-remarks`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setRemarksData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addRemarkHandler = async () => {
    if (remarkName == "") {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      name: remarkName,
    };
    setAddClassLoading(true);

    await fetch(`${baseUrl}/exam-remarks`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Exam Remark successfully added");
            setAddRemarkModal(false);
            setAddClassLoading(false);
            getExamRemarks();
            setRemarkName("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddRemarkModal(false);
            setAddClassLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddRemarkModal(false);
            setAddClassLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddClassLoading(false);
        setAddRemarkModal(false);
        console.log(err);
      });
  };

  const getEditRemark = async (id) => {
    await fetch(`${baseUrl}/exam-remarks/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditRemarkName(data.payload?.name);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateRemarkHandler = async () => {
    if (editRemarkName == "") {
      return alert.error("Exam Remark Name Is Required");
    }

    setSubmitLoading(true);
    const data = {
      name: editRemarkName,
    };
    setSubmitLoading(false);
    await fetch(`${baseUrl}/exam-remarks/${editRemarkId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Exam Remark Successfully Updated");
            getExamRemarks();
            setEditRemarkModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditRemarkModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditRemarkModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteRemarkHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/exam-remarks/${deleteRemarkId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.payload);
            getExamRemarks();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddRemarkModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Exam Remark
          </button>
        </div>

        <Table className="mt-5">
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Exam Remark</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {remarksData?.map((classes, index) => (
              <tr className="text-center" key={index}>
                <td>{classes.id}</td>
                <td className="text-start">{classes.name}</td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                    onClick={() => {
                      getEditRemark(classes?.id);
                      setEditRemarkId(classes?.id);
                      setEditRemarkModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                    onClick={() => {
                      setDeleteRemarkId(classes?.id);
                      setdeleteModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Delete-user.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add Class Modal */}
        <Modal show={addRemarkModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add New Exam Remark
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Exam Remark <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={remarkName}
                onChange={(e) => setRemarkName(e.target.value)}
                placeholder="Enter Exam Remark"
              />
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addClassLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addRemarkHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddRemarkModal(false);
                setisallfields(false);
                setRemarkName("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Class Modal */}
        <Modal show={editRemarkModal} size="md">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Exam Remark
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-4">
              <label className="form-control-label">
                <b>
                  Enter Exam Remark <span style={{ color: "red" }}>*</span>{" "}
                </b>
              </label>
              <input
                className="form-control"
                value={editRemarkName}
                onChange={(e) => setEditRemarkName(e.target.value)}
                placeholder="Enter Exam Remark"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={updateRemarkHandler} className="btn btn-primary">
                Update
              </button>
            )}

            <button
              onClick={() => setEditRemarkModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Campus Class Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this exam remark?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Class Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteRemarkHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default DefineExamRemarks;
